import React, { ReactNode, FC } from 'react'
import { Box, Flex, Link, Text } from 'front-end/src/components'
import { brandColors } from '../../../../../shared/basicPalette'
import { useLooopTheme } from '../../../public-api/hooks/useLooopTheme'
import Tooltip from '../tooltip/Tooltip'

export const RelatedInstancesWrapper = ({
  children
}: {
  children: ReactNode
}) => (
  <Box
    mt="8px"
    borderY={`1px solid ${brandColors.grey['100']}`}
    maxH="250px"
    overflow="auto"
    py="2px"
  >
    {children}
  </Box>
)

type RelatedItemProps = {
  id: string | number
  href: string
  icon: ReactNode
  name: string
  info?: string | JSX.Element
  additionalInfo?: string | JSX.Element
  tooltip?: string
}

export const RelatedInstanceItem: FC<RelatedItemProps> = ({
  id,
  href,
  icon,
  name,
  additionalInfo = '',
  tooltip = '',
  info
}) => {
  const { theme } = useLooopTheme()
  return (
    <Link
      key={id}
      py="3px"
      px="6px"
      display="block"
      href={href}
      borderRadius="4px"
      color={brandColors.grey.dark}
      border="1px solid transparent"
      _hover={{
        textDecoration: 'none',
        borderColor: theme.colors.buttonPrimary.default
      }}
      dataTest="RelatedCampaign"
    >
      <Tooltip text={tooltip}>
        <Flex align="center" justify="space-between">
          <Box marginRight="auto">
            {icon}
            <Text fontWeight="500" ml="8px" as="span" fontSize="sm">
              {name}
            </Text>
          </Box>
          {info && (
            <Text
              marginX="12px"
              fontSize="sm"
              ml="4px"
              color={brandColors.grey.mid}
              as="span"
            >
              {info}
            </Text>
          )}
          <Text fontSize="sm" ml="4px" color={brandColors.grey.mid} as="span">
            {additionalInfo}
          </Text>
        </Flex>
      </Tooltip>
    </Link>
  )
}
